import { render, staticRenderFns } from "./ButtonAccount.vue?vue&type=template&id=38a17c6e&scoped=true&"
import script from "./ButtonAccount.vue?vue&type=script&lang=js&"
export * from "./ButtonAccount.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAccount.vue?vue&type=style&index=0&id=38a17c6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a17c6e",
  null
  
)

export default component.exports